import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchJournalRecord = createAsyncThunk(
  "journalRecord/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      let url = "/reports/get-journals";
      if (filters?.recordType === "with details") {
        url = "/accounts/get-journal-with-details";
      }
      if (filters?.filterType === "By Account") {
        url = "/reports/get-journal-record-details";
      }

      const payload = {
        selectedFilterType: filters?.filterType,
        accId: filters?.accountId || null,
        userId: filters?.userId || null,
        fromDate: filters?.fromDate || null,
        toDate: filters?.toDate || null,
      };

      const res = await postData(url, payload);

      let mapped = [];
      if (filters?.filterType === "By Account") {
          mapped = res.data.map((row, idx) => ({
            id: row.id || idx,
            jrnCode: row.jrn_code,
            date: row.created_date,
            journalBy: row.full_name,
            debitTotal: Number(row.debit_amount || 0),
            creditTotal: Number(row.credit_amount || 0),
            account:row.acc_name
          }));
      } else {
        if (filters?.recordType === "with details") {
          mapped = res.data.map((row, idx) => ({
            id: row.id || idx,
            jrnCode: row.jrn_code,
            date: row.created_date,
            journalBy: row.full_name,
            accName: row.acc_name,
            details: row.details || [],
            debitTotal: Number(row.debit_total || 0),
            creditTotal: Number(row.credit_total || 0),
          }));
        } else {
          mapped = res.data.map((row, idx) => ({
            id: row.id || idx,
            jrnCode: row.jrn_code,
            date: row.created_date,
            journalBy: row.full_name,
            debitTotal: Number(row.debit_total || 0),
            creditTotal: Number(row.credit_total || 0),
          }));
        }
      }
      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchAccountsBySearch = createAsyncThunk(
  "journalRecord/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        search: true,
        multiType: [
          "investment",
          "capital",
          "cash_in_hand",
          "bank_account",
          "indirect_expense",
          "loan",
          "fixed_asset",
        ],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
